import React, { lazy, Suspense } from 'react';
import PropTypes from 'prop-types';
import Loader from '~/components/Loader/Loader';

const PlaybookExecuteDetails = lazy(() =>
    import(
        /* webpackChunkName: "PlaybookExecuteDetailsComponent" */
        './PlaybookExecuteDetails'
    )
);

/**
 * Page/Route level component for Playbook Execute Details
 * Extracts playbookId and executionId from props or route params
 */
function PlaybookExecuteDetailsPage(props) {
    // Extract playbookId and executionId from match.params
    let playbookId = null;
    let executionId = null;

    if (props.match?.params?.playbook_id) {
        const playbookParam = props.match.params.playbook_id;

        // Check if the param contains both ID and execution ID (format: "id-executionId")
        if (playbookParam.split('-').length === 2) {
            const parts = playbookParam.split('-');
            playbookId = parts[0];
            executionId = parts[1];
        } else {
            playbookId = playbookParam;
        }
    }

    return (
        <Suspense fallback={<Loader />}>
            <PlaybookExecuteDetails
                playbookId={playbookId}
                executionId={executionId}
            />
        </Suspense>
    );
}

PlaybookExecuteDetailsPage.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            playbook_id: PropTypes.string
        })
    })
};

export default PlaybookExecuteDetailsPage;
